import Vue from 'vue'
import axios from 'axios'
import config from './config'

let apiURL = config.API_URL_LOCAL;
let isLocal = false;
// console.log(window.location.href);
if (window.location.href.indexOf("boardroomlimited.com") > -1) {
  if (window.location.href.indexOf("lamac") > -1) {
    apiURL = config.API_URL_CLIENT_UAT;

    if (window.location.href.indexOf("http://") > -1) {
      apiURL = apiURL.replace("https://", "http://");
    }
  }
  else {
    apiURL = config.API_URL_PROD;
    if (window.location.href.indexOf("http://") > -1) {
      apiURL = apiURL.replace("https://", "http://");
    }
  }
}
else if (window.location.href.indexOf("lamac.brl.local") > -1) {
  apiURL = config.API_URL_UAT;
}
else {
  isLocal = true;
}

Vue.prototype.$backendUrl = apiURL;
const jsonRequest = axios.create({
  baseURL: apiURL
})

export default {
  isLocal() {
    return isLocal;
  },
  //administrators
  getAdministrators(payload) {
    return jsonRequest.post('/admin/get', payload)
  },
  deleteAdministrator(payload) {
    return jsonRequest.post('/admin/delete', payload)
  },
  saveAdministrator(payload) {
    return jsonRequest.post('/admin/save', payload)
  },
  toggleAdministrator(payload) {
    return jsonRequest.post('/admin/toggle', payload)
  },

  //account
  login(payload) {
    return jsonRequest.post('/login', payload)
  },
  ssologin(payload) {
    return jsonRequest.post('/ssologin', payload)
  },
  changePassword(payload) {
    return jsonRequest.post('/change-password', payload)
  },

  //insurance type
  getInsuranceType(payload) {
    return jsonRequest.post('/insurance-type/get', payload)
  },
  deleteInsuranceType(payload) {
    return jsonRequest.post('/insurance-type/delete', payload)
  },
  saveInsuranceType(payload) {
    return jsonRequest.post('/insurance-type/save', payload)
  },
  toggleInsuranceType(payload) {
    return jsonRequest.post('/insurance-type/toggle', payload)
  },

  //enrolment category
  getEnrolmentCategory(payload) {
    return jsonRequest.post('/enrolment-category/get', payload)
  },
  deleteEnrolmentCategory(payload) {
    return jsonRequest.post('/enrolment-category/delete', payload)
  },
  saveEnrolmentCategory(payload) {
    return jsonRequest.post('/enrolment-category/save', payload)
  },
  toggleEnrolmentCategory(payload) {
    return jsonRequest.post('/enrolment-category/toggle', payload)
  },

  //insurance type + enrolment category mapping
  getInsuranceCategoryMapping(payload) {
    return jsonRequest.post('/insurance-category-mapping/get', payload)
  },
  saveInsuranceCategoryMapping(payload) {
    return jsonRequest.post('/insurance-category-mapping/save', payload)
  },
  toggleInsuranceCategoryMapping(payload) {
    return jsonRequest.post('/insurance-category-mapping/toggle', payload)
  },
  getInsuranceCategoryMappingInsuranceTypes(payload) {
    return jsonRequest.post('/insurance-category-mapping/insurance-types', payload)
  },
  getInsuranceCategoryMappingEnrolmentCategories(payload) {
    return jsonRequest.post('/insurance-category-mapping/enrolment-categories', payload)
  },

  //employee insurances
  getEmployeeInsurance(payload) {
    return jsonRequest.post('/employee-insurance/get', payload)
  },
  deleteEmployeeInsurance(payload) {
    return jsonRequest.post('/employee-insurance/delete', payload)
  },
  saveEmployeeInsurance(payload) {
    return jsonRequest.post('/employee-insurance/save', payload)
  },
  getEmployeeInsuranceDetail(payload) {
    return jsonRequest.post('/employee-insurance/detail', payload)
  },
  submitNewEmployeeInsuranceDependent(payload) {
    return jsonRequest.post('/employee-insurance/submit-new-employee', payload)
  },
  getEmployeInsuranceSelection(payload) {
    return jsonRequest.post('/employee-insurance/selection', payload)
  },
  getEmployeeInsuranceSubmissions(payload) {
    return jsonRequest.post('/employee-insurance/submissions', payload)
  },

  //employee dependents
  getEmployeeDependent(payload) {
    return jsonRequest.post('/employee-dependent/get', payload)
  },
  deleteEmployeeDependent(payload) {
    return jsonRequest.post('/employee-dependent/delete', payload)
  },
  saveEmployeeDependent(payload) {
    return jsonRequest.post('/employee-dependent/save', payload)
  },
  getEmployeeDependentDetail(payload) {
    return jsonRequest.post('/employee-dependent/detail', payload)
  },
  getEmployeeDependentNames(payload) {
    return jsonRequest.post('/employee-dependent/dependent-names', payload)
  },
  getEmployeeDependentDetailByName(payload) {
    return jsonRequest.post('/employee-dependent/detail-by-name', payload)
  },
  getEmployeeDependentsByCategory(payload) {
    return jsonRequest.post('/employee-dependent/by-category', payload)
  },

  //enhanced insurance dependent
  getDependentAgeSetting(payload) {
    return jsonRequest.post('/dependent-age-setting/get', payload)
  },
  saveDependentAgeSetting(payload) {
    return jsonRequest.post('/dependent-age-setting/save', payload)
  },
  deleteDependentAgeSetting(payload) {
    return jsonRequest.post('/dependent-age-setting/delete', payload)
  },
  getLrsInsuranceRenewalReport(payload) {
    return jsonRequest.post('/report/lrsInsuranceRenewal', payload)
  },
  getLrmInsuranceRenewalReport(payload) {
    return jsonRequest.post('/report/lrmInsuranceRenewal', payload)
  },
  getIdentityTypeMapping(payload) {
    return jsonRequest.post('/identity-type-mapping/get', payload)
  },
  saveIdentityTypeMapping(payload) {
    return jsonRequest.post('/identity-type-mapping/save', payload)
  },

  //group
  getGroup(payload) {
    return jsonRequest.post('/group/get', payload)
  },
  deleteGroup(payload) {
    return jsonRequest.post('/group/delete', payload)
  },
  saveGroup(payload) {
    return jsonRequest.post('/group/save', payload)
  },
  toggleGroup(payload) {
    return jsonRequest.post('/group/toggle', payload)
  },

  //benefit option
  getBenefitOption(payload) {
    return jsonRequest.post('/benefit-option/get', payload)
  },
  deleteBenefitOption(payload) {
    return jsonRequest.post('/benefit-option/delete', payload)
  },
  saveBenefitOption(payload) {
    return jsonRequest.post('/benefit-option/save', payload)
  },
  toggleBenefitOption(payload) {
    return jsonRequest.post('/benefit-option/toggle', payload)
  },

  //benefit item
  getBenefitItem(payload) {
    return jsonRequest.post('/benefit-item/get', payload)
  },
  deleteBenefitItem(payload) {
    return jsonRequest.post('/benefit-item/delete', payload)
  },
  saveBenefitItem(payload) {
    return jsonRequest.post('/benefit-item/save', payload)
  },
  toggleBenefitItem(payload) {
    return jsonRequest.post('/benefit-item/toggle', payload)
  },

  //benefit option + benefit item mapping
  getBenefitOptionItemMapping(payload) {
    return jsonRequest.post('/benefit-option-item-mapping/get', payload)
  },
  saveBenefitOptionItemMapping(payload) {
    return jsonRequest.post('/benefit-option-item-mapping/save', payload)
  },

  //employee's benefit option
  getBenefitOptions(payload) {
    return jsonRequest.post('/employee-benefit/benefit-options', payload)
  },
  saveEmployeeBenefitOption(payload) {
    return jsonRequest.post('/employee-benefit/save', payload)
  },
  getEmployeeBenefitOptionDetail(payload) {
    return jsonRequest.post('/employee-benefit/detail', payload)
  },
  getEmployeeBenefit(payload) {
    return jsonRequest.post('/employee-benefit/get', payload)
  },
  deleteEmployeeBenefit(payload) {
    return jsonRequest.post('/employee-benefit/delete', payload)
  },

  //enrolment period
  getEnrolmentPeriod(payload) {
    return jsonRequest.post('/enrolment-period/get', payload)
  },
  saveEnrolmentPeriod(payload) {
    return jsonRequest.post('/enrolment-period/save', payload)
  },
  saveEnrolmentPeriodInstruction(payload) {
    return jsonRequest.post('/enrolment-period/instruction/save', payload)
  },

  //setting
  getSettings(payload) {
    return jsonRequest.post('/settings/get', payload)
  },
  saveSettings(payload) {
    return jsonRequest.post('/settings/save', payload)
  },
  getHeaderMessage(payload) {
    return jsonRequest.post('/settings/header-message', payload)
  },

  //overtime payment calculation
  getOvertimePaymentCalculation(payload) {
    return jsonRequest.post('/overtimepaymentcalculation/get', payload)
  },
  saveOvertimePaymentCalculation(payload) {
    return jsonRequest.post('/overtimepaymentcalculation/save', payload)
  },

  //timesheet
  getTimesheet(payload) {
    return jsonRequest.post('/timesheet/get', payload)
  },
  getManagerTimesheet(payload) {
    return jsonRequest.post('/timesheet/managerGet', payload)
  },
  loadTimesheet(payload) {
    return jsonRequest.post('/timesheet/load', payload)
  },
  saveTimesheet(payload) {
    return jsonRequest.post('/timesheet/save', payload)
  },
  submitTimesheet(payload) {
    return jsonRequest.post('/timesheet/submit', payload)
  },
  saveChangesTimesheet(payload) {
    return jsonRequest.post('/timesheet/change', payload)
  },
  approveTimesheet(payload) {
    return jsonRequest.post('/timesheet/approve', payload)
  },
  rejectTimesheet(payload) {
    return jsonRequest.post('/timesheet/reject', payload)
  },
  changeToDraftTimesheet(payload) {
    return jsonRequest.post('/timesheet/changeToDraft', payload)
  },
  searchTimesheet(payload) {
    return jsonRequest.post('/timesheet/search', payload)
  },
  searchMonthlyOvertimeTimesheet(payload) {
    return jsonRequest.post('/timesheet-report/monthly-overtime', payload)
  },
  searchMonthlyOvertimeStandbyShiftAllowanceTimesheet(payload) {
    return jsonRequest.post('/timesheet-report/monthly-overtime-standby-shift-allowance', payload)
  },
  searchImportList(payload) {
    return jsonRequest.post('/timesheet-import/list', payload)
  },
  searchImportDetailList(payload) {
    return jsonRequest.post('/timesheet-import/detail', payload)
  },
  getImportEmployees(payload) {
    return jsonRequest.post('/timesheet-import/detail/employees', payload)
  },
  overwriteImportedEmployeeData(payload) {
    return jsonRequest.post('/timesheet-import/overwrite', payload);
  },
  getTimesheetLogs(payload) {
    return jsonRequest.post('/timesheet/logs', payload)
  },
  checkNewLayout(payload) {
    return jsonRequest.post('/timesheet/checknewlayout', payload)
  },
  calculateSwingShiftAllowance(payload) {
    return jsonRequest.post('/timesheet/calculateswingshiftallowance', payload)
  },
  checkMixedLayout(payload) {
    return jsonRequest.post('/timesheet-report/checkmixedlayout', payload)
  },
  getImportNotificationRecipients(payload) {
    return jsonRequest.post('/timesheet-import/notification-recipients', payload);
  },
  saveImportNotificationRecipients(payload) {
    return jsonRequest.post('/timesheet-import/notification-recipients/save', payload);
  },

  //common
  verifyToken(payload) {
    return jsonRequest.post('/token/verify', payload)
  },
  getDashboardData(payload) {
    return jsonRequest.post('/dashboardData', payload)
  },
  getEmployees(payload) {
    return jsonRequest.post('/employees', payload)
  },
  getManagers(payload) {
    return jsonRequest.post('/managers', payload)
  },
  getManagerEmployees(payload) {
    return jsonRequest.post('/managerEmployees', payload)
  },
  getNextManagerEmployees(payload) {
    return jsonRequest.post('/nextManagerEmployees', payload)
  },
  getManagerEmployeeCompanies(payload) {
    return jsonRequest.post('/managerEmployeeCompanies', payload)
  },
  getEmployeeDetail(payload) {
    return jsonRequest.post('/employee-detail', payload)
  },
  getYears(payload) {
    return jsonRequest.post('/years', payload)
  },
  getCompanies(payload) {
    return jsonRequest.post('/companies', payload)
  },
  getAllCompanies(payload) {
    return jsonRequest.post('/allcompanies', payload)
  },
  getDepartments(payload) {
    return jsonRequest.post('/departments', payload)
  },
  getJobGrades(payload) {
    return jsonRequest.post('/jobGrades', payload)
  },
  getCostCentres(payload) {
    return jsonRequest.post('/costCentres', payload)
  },
  getDesignations(payload) {
    return jsonRequest.post('/designations', payload)
  },
  getAttendanceReportSelection(payload) {
    return jsonRequest.post('/attendanceReportSelection', payload)
  },

  //report
  getInsuranceReport(payload) {
    return jsonRequest.post('/report/insurance', payload)
  },
  getBenefitReport(payload) {
    return jsonRequest.post('/report/benefit', payload)
  },

  //data import
  importInsuranceDependentData(payload) {
    return jsonRequest.post('/insurance-dependent/import', payload)
  },
  uploadCADOData(payload) {
    return jsonRequest.post('/timesheet-upload/cado', payload)
  },

  //carpark
  getCarparkClaimFormData(payload) {
    return jsonRequest.post('/carpark-claim-form/get', payload)
  },
  saveCarparkClaimFormAsDraft(payload) {
    return jsonRequest.post('/carpark-claim-form/save-draft', payload)
  },
  submitCarparkClaimForm(payload) {
    return jsonRequest.post('/carpark-claim-form/submit', payload)
  },
  getCarparkClaims(payload) {
    return jsonRequest.post('/carpark-claims/get', payload)
  },
  approveCarparkClaim(payload) {
    return jsonRequest.post('/carpark-claim/approve', payload)
  },
  rejectCarparkClaim(payload) {
    return jsonRequest.post('/carpark-claim/reject', payload)
  },
  saveChangeCarparkClaim(payload) {
    return jsonRequest.post('/carpark-claim/save-change', payload)
  },
  changeCarparkClaimToDraft(payload) {
    return jsonRequest.post('/carpark-claim/change-to-draft', payload)
  },
  getCarparkClaimReport(payload) {
    return jsonRequest.post('/carpark-claim/report', payload)
  },
  getManagerCarparkClaim(payload) {
    return jsonRequest.post('/carpark-claim/managerGet', payload)
  },

  //corporate pass
  getCorporatePassDetail(payload) {
    return jsonRequest.post('/corporate-pass/detail', payload)
  },
  saveCorporatePass(payload) {
    return jsonRequest.post('/corporate-pass/save', payload)
  },
  getCorporatePass(payload) {
    return jsonRequest.post('/corporate-pass/get', payload)
  },
  deleteCorporatePass(payload) {
    return jsonRequest.post('/corporate-pass/delete', payload)
  },
  getCorporatePassBlockingDates(payload) {
    return jsonRequest.post('/corporate-pass/blocking-date/get', payload)
  },
  saveCorporatePassBlockingDate(payload) {
    return jsonRequest.post('/corporate-pass/blocking-date/save', payload)
  },
  getCorporatePassBlockingDateDetail(payload) {
    return jsonRequest.post('/corporate-pass/blocking-date/detail', payload)
  },
  deleteCorporatePassBlockingDate(payload) {
    return jsonRequest.post('/corporate-pass/blocking-date/delete', payload)
  },
  getCorporatePassOption(payload) {
    return jsonRequest.post('/corporate-pass/option/get', payload)
  },
  saveCorporatePassOption(payload) {
    return jsonRequest.post('/corporate-pass/option/save', payload)
  },
  getCorporatePassBookingHistory(payload) {
    return jsonRequest.post('/corporate-pass/booking-history/get', payload)
  },
  getCorporatePassBookingDetail(payload) {
    return jsonRequest.post('/corporate-pass/booking/detail', payload)
  },
  saveCorporatePassBookingDetail(payload) {
    return jsonRequest.post('/corporate-pass/booking/save', payload)
  },
  getCorporatePassBookings(payload) {
    return jsonRequest.post('/corporate-pass/bookings/get', payload)
  },
  bookCorporatePass(payload) {
    return jsonRequest.post('/corporate-pass/book', payload)
  },

  //public holiday
  getPublicHolidays(payload) {
    return jsonRequest.post('/public-holiday/get', payload)
  },
  savePublicHoliday(payload) {
    return jsonRequest.post('/public-holiday/save', payload)
  },

  //delegation
  deleteDelegation(payload) {
    return jsonRequest.post('/delegation/delete', payload)
  },
  getDelegations(payload) {
    return jsonRequest.post('/delegation/get', payload)
  },
  saveDelegation(payload) {
    return jsonRequest.post('/delegation/save', payload)
  },
  getDelegationDetail(payload) {
    return jsonRequest.post('/delegation/detail', payload)
  },
  getDelegators(payload) {
    return jsonRequest.post('/delegation/delegators', payload)
  },
  getDelegatees(payload) {
    return jsonRequest.post('/delegation/delegatees', payload)
  },
  saveDelegation(payload) {
    return jsonRequest.post('/delegation/save', payload)
  },
  getOngoingDelegations(payload) {
    return jsonRequest.post('/delegation/ongoing', payload)
  },

  //leave
  getLeaveNames(payload) {
    return jsonRequest.post('/leave-name/get', payload)
  },
  deleteLeaveType(payload) {
    return jsonRequest.post('/leave-type/delete', payload)
  },
  saveLeaveType(payload) {
    return jsonRequest.post('/leave-type/save', payload)
  },
  getLeaveTypes(payload) {
    return jsonRequest.post('/leave-type/get', payload)
  },
  getEmployeeLeaves(payload) {
    return jsonRequest.post('/employee-leave/get', payload)
  },
  getActiveLeaveTypes(payload) {
    return jsonRequest.post('/active-leave-type/get', payload)
  },
  getEmployeeLeavesReport(payload) {
    return jsonRequest.post('/employee-leave-report/get', payload)
  },
  getLeaveReasonsCorporate(payload) {
    return jsonRequest.post('/leave-reasons-corporate/get', payload)
  },
  saveLeaveReasonsCorporate(payload) {
    return jsonRequest.post('/leave-reasons-corporate/save', payload)
  },
  getCalculationTypes(payload) {
    return jsonRequest.post('/calculation-types/get', payload)
  },
  saveCalculationTypes(payload) {
    return jsonRequest.post('/calculation-types/save', payload)
  },
  getLoaHolidays(payload) {
    return jsonRequest.post('/loa-holiday/get', payload)
  },
  saveLoaHolidays(payload) {
    return jsonRequest.post('/loa-holiday/save', payload)
  },

  //log
  getEmailLogs(payload) {
    return jsonRequest.post('/email-log/get', payload)
  },
  getSyncLogs(payload) {
    return jsonRequest.post('/sync-log/get', payload)
  },

  //reminder
  deleteReminder(payload) {
    return jsonRequest.post('/reminder/delete', payload)
  },
  getReminders(payload) {
    return jsonRequest.post('/reminder/get', payload)
  },
  toggleReminder(payload) {
    return jsonRequest.post('/reminder/toggle', payload)
  },
  getReminderDetail(payload) {
    return jsonRequest.post('/reminder/detail', payload)
  },
  saveReminder(payload) {
    return jsonRequest.post('/reminder/save', payload)
  },

  //work calendar
  getWorkCalendars(payload) {
    return jsonRequest.post('/workcalendar/get', payload)
  },
  saveWorkCalendar(payload) {
    return jsonRequest.post('/workcalendar/save', payload)
  },

  //menu
  getMenus(payload) {
    return jsonRequest.post('/menu/get', payload)
  },
  saveMenus(payload) {
    return jsonRequest.post('/menu/save', payload)
  },

  //fwa
  getFwaSetup(payload) {
    return jsonRequest.post('/fwa/setup', payload)
  },
  saveFwaSetup(payload) {
    return jsonRequest.post('/fwa/setup/save', payload)
  },
  getFwaApprovers(payload) {
    return jsonRequest.post('/fwa/approvers', payload)
  },
  saveFwaApprovers(payload) {
    return jsonRequest.post('/fwa/approvers/save', payload)
  },
  getFwaDetail(payload) {
    return jsonRequest.post('/fwa/detail', payload)
  },
  validateFwaSubmission(payload) {
    return jsonRequest.post('/fwa/submit/validate', payload)
  },
  submitFwa(payload) {
    return jsonRequest.post('/fwa/submit', payload)
  },
  getFwaApproverInfo(payload) {
    return jsonRequest.post('/fwa/approver/info', payload)
  },
  getAllFwaApprovers(payload) {
    return jsonRequest.post('/fwa/approvers/all', payload)
  },
  getFwaRecords(payload) {
    return jsonRequest.post('/fwa/records', payload)
  },
  getFwaReport(payload) {
    return jsonRequest.post('/fwa/report', payload)
  },
  getManagerFwaPendingList(payload) {
    return jsonRequest.post('/fwa/manager-pending-list', payload)
  },

  //oil report
  getOilReport(payload) {
    return jsonRequest.post('/oil-report', payload)
  },

  //leave utilization report
  getShutdownCarryForward(payload) {
    return jsonRequest.post('/leave-utilization-report/shutdown-carry-forward', payload)
  },
  saveShutdownCarryForward(payload) {
    return jsonRequest.post('/leave-utilization-report/shutdown-carry-forward/save', payload)
  },
  getLeaveUtilizationReport(payload) {
    return jsonRequest.post('/leave-utilization-report', payload)
  },
  getLeaveUtilizationReportEmployeeRange(payload) {
    return jsonRequest.post('/leave-utilization-report/employee-range', payload)
  },

  //swing shift
  getShiftCodes(payload) {
    return jsonRequest.post('/swing-shift/shift-codes', payload)
  },
  saveShiftCodes(payload) {
    return jsonRequest.post('/swing-shift/shift-codes/save', payload)
  },
  getLeaveHolidays(payload) {
    return jsonRequest.post('/leave-holiday/get', payload)
  },
  saveLeaveHoliday(payload) {
    return jsonRequest.post('/leave-holiday/save', payload)
  },
  deleteApplicableLeaveType(payload) {
    return jsonRequest.post('/applicable-leave-type/delete', payload)
  },
  saveApplicableLeaveType(payload) {
    return jsonRequest.post('/applicable-leave-type/save', payload)
  },
  getApplicableLeaveTypes(payload) {
    return jsonRequest.post('/applicable-leave-type/get', payload)
  },

  //loa collection report
  getLoaCollectionReportSelection(payload) {
    return jsonRequest.post('/loaCollectionReportSelection/get', payload)
  },
  getLoaCollectionReport(payload) {
    return jsonRequest.post('/loa-collection-report/get', payload)
  },

  //manual sync
  triggerManualSync(payload) {
    return jsonRequest.post('/triggerManualSync', payload)
  },
  triggerManualSyncRoster(payload) {
    return jsonRequest.post('/triggerManualSyncRoster', payload)
  },

  //query tool
  executeQuery(payload) {
    return jsonRequest.post('/executeQuery', payload)
  },

  //location
  getLocations(payload) {
    return jsonRequest.post('/location/get', payload)
  },
  saveLocations(payload) {
    return jsonRequest.post('/location/save', payload)
  },
}


// WEBPACK FOOTER //
// ./src/http-common.js